import React from 'react';
import { Home, MessageCircle, BarChart3, Radio } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const BottomNav = ({ activeTab = 'crm', onTabChange }) => {
  const navigate = useNavigate();

  const tabs = [
    { id: 'crm', icon: MessageCircle, label: 'CRM', onClick: () => {} },
    { id: 'dash', icon: BarChart3, label: 'Panel', onClick: () => navigate('/dashboard') },
    { id: 'broadcast', icon: Radio, label: 'Envíos', onClick: () => onTabChange && onTabChange('broadcast') },
    { id: 'home', icon: Home, label: 'Líneas', onClick: () => onTabChange && onTabChange('home') }
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 flex h-16 bg-[#0f1420] border-t border-emerald-500/25 px-1 pb-[env(safe-area-inset-bottom)] shadow-[0_-6px_18px_rgba(0,0,0,0.4)]">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={tab.onClick}
            className={`flex-1 flex flex-col items-center justify-center gap-1 mx-1 my-1 rounded-[10px] transition-colors ${
              isActive
                ? 'bg-emerald-500/15 text-emerald-300'
                : 'text-[#8892a4] hover:text-[#e8ecf4]'
            }`}
          >
            <Icon className="w-[22px] h-[22px] shrink-0" strokeWidth={isActive ? 2.5 : 2} />
            <span className="text-[10px] font-black tracking-wide leading-none">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
};
